export default __webpack_public_path__ + "static/media/14 - Web.config (1).a91ab832.png";